import { Heading, Modal, ModalProps, RequiredKeys, Row } from "@hex-insights/core";
import { Icon, IconContainer } from "../../../../Components/Icon";
import { StudentMedicalEventDetailFragment } from "../../../../Utilities";
import { StudentMedicalEventForm } from "../../../Forms";

export type StudentMedicalEventUpdateModalProps = {
	studentMedicalEvent: StudentMedicalEventDetailFragment;
} & Pick<StudentMedicalEventForm.ControlledDetailProps, "formStateArgs"> &
	RequiredKeys<Pick<ModalProps, "ifRef" | "onClose" | "className" | "style">, "onClose">;

export function StudentMedicalEventUpdateModal({
	studentMedicalEvent,
	formStateArgs,
	ifRef,
	onClose,
	className,
	style,
}: StudentMedicalEventUpdateModalProps) {
	return (
		<Modal ifRef={ifRef} onClose={onClose} className={className} style={style}>
			<Modal.Header>
				<Row justify="spaced-start" align="center">
					<IconContainer color="var(--theme-colors__pink--background)">
						<Icon.FirstAidKit color="var(--theme-colors__pink)" size={22} />
					</IconContainer>

					<Heading.H2 noMargin>Edit Medical Event</Heading.H2>
				</Row>
			</Modal.Header>
			<Modal.Body>
				<StudentMedicalEventForm.ControlledDetail
					studentMedicalEvent={studentMedicalEvent}
					formStateArgs={formStateArgs}
					onSuccess={onClose}
				/>
			</Modal.Body>
		</Modal>
	);
}
